<!--编辑库存-->
<template>
<div>
    <el-form label-width="80px" :model="inventory" size="mini">
        <el-row type="flex" justify="start" style="flex-wrap: wrap;">
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('库存编号')" >
                    <el-input v-model="inventory.code" placeholder="请输入库存编号" disabled size="mini"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('货号')" >
                    <el-input v-model="inventory.variationSku" placeholder="请输入货号" size="mini"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('SKU')" >
                    <el-input v-model="inventory.sku" placeholder="请输入SKU" size="mini"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('规格')" >
                    <el-input v-model="inventory.spec" placeholder="请输入规格" size="mini"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('标题')" >
                    <el-input v-model="inventory.title" placeholder="请输入标题" size="mini"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('退件单号')" >
                    <el-input v-model="inventory.backCode" placeholder="请输入退件单号" :disabled="enableBackCode && inventory.allowEdit" size="mini"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('退件费用')" >
                    <el-input-number v-model="inventory.amtBack" controls-position="right" :disabled="inventory.allowEdit" :min="0"></el-input-number>
                </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('退件受理')" >
                    <el-input v-model="inventory.backAccept" placeholder="请输入退件受理" :disabled="inventory.allowEdit" size="mini"></el-input>
                </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('采购平台')" >
                    <el-select v-model="inventory.productOrigin"
                        placeholder="选择采购平台" size="small">
                        <el-option
                            v-for="item in this.dicts.productOrigin"
                            :key="item.value" 
                            :label="item.label"
                            :value="item.value"> 
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('采购链接')" >
                    <el-input type="textarea" v-model="inventory.productLink" placeholder="请输入采购链接" size="mini" autosize maxlength="128" show-word-limit></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('安全库存')" >
                    <el-input-number v-model="inventory.safeQty" controls-position="right" :min="0"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('售价')" >
                    <el-input-number v-model="inventory.price" controls-position="right" :min="0"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" >
                <el-form-item :label="msg('成本')" >
                    <el-input-number v-model="inventory.cost" controls-position="right" :min="0"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :xs="24" >
                <el-form-item :label="msg('产品图')">
                    <el-upload class="xm-upload" 
                            :action="upload"
                            :show-file-list="false"
                            :with-credentials="true"
                            list-type="picture-card"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <div style="text-align:center; margin-top: 15px;">
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
        <el-button type="primary" size="mini"  @click="onSubmit()"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
    </div>

</div>
</template>
<script>
export default {
    name: "InventoryEditDrawer",
    components: { 
    },
    mounted: function(){
        // let status = this.inventory.status;
        // if(status == 107 || status == 110){
        //     this.enableBackCode = false;
        // }
    },
    data() {
        return {
            upload: this.$kit.api.upload+"?type=inventory&auth=1",
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        imageUrl:{
          get(){
              if(this.inventory.thumbId){
                  return this.$kit.api.imgView+this.inventory.thumbId;
              }
              return null;
          }
        },
        enableBackCode:{
            get(){
                let status = this.inventory.status;
                let allowEdit = this.inventory.allowEdit;
                if((status == 107 || status == 110) && !allowEdit){
                    return false;
                }
                return true;
          }
        }
    },
    props: {
        inventory:Object
    },
    methods: {
        handleAvatarSuccess(res, file,fileList) {
            if(res.status){
                this.inventory.thumbId = res.data;
            }else{
                this.$message(res.msg || this.msg("上传失败"));
            }
        },
        beforeAvatarUpload(){
            return true;
        },
        onSubmit(){
            
            if(this.inventory.cost){
                this.inventory.cost = this.inventory.cost*100;
            }
            if(this.inventory.price){
                this.inventory.price = this.inventory.price*100;
            }
            if(this.inventory.amtBack){
                this.inventory.amtBack = this.inventory.amtBack*100;
            }

            var _this = this;
            this.$axios.post(this.$kit.api.inventory.update,this.inventory)
            .then((result) => {
                this.$message(result.msg);
                if(result.status){
                    _this.$emit("close-dg", true);
                }
            });

        },
    }
}
</script>
<style lang="scss" scoped>
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>